module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_c('img', {
    attrs: {
      "alt": "img2.jpg",
      "height": "48",
      "src": "Images/img2.jpg",
      "width": "48"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Published by")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("D"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents either are the product of author imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("The Shared Harvest")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("© 2015 D.W. Marchwell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Cover Art")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("© 2015 L.C. Chase.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("http://www.lcchase.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Cover content is for illustrative purposes only and any person depicted on the cover is a model.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("All rights reserved. This book is licensed to the original purchaser only. Duplication or distribution via any means is illegal and a violation of international copyright law, subject to criminal prosecution and upon conviction, fines, and/or imprisonment. Any eBook format cannot be legally loaned or given to others. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without the written permission of the Publisher, except where permitted by law. To request permission and all other inquiries, contact Dreamspinner Press, 5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886, USA, or http://www.dreamspinnerpress.com/.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("ISBN: 978-1-63216-849-8")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Digital ISBN: 978-1-63216-850-4")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Library of Congress Control Number: 2014922891")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("First Edition May 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_c('img', {
    attrs: {
      "alt": "img3.jpg",
      "height": "13",
      "src": "Images/img3.jpg",
      "width": "13"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("This paper meets the requirements of")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("ANSI/NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0